<template>
  <v-item-group :value="item" active-class="hvh-card--teal" :mandatory="true" @change="$emit('update:item', $event)">
    <v-container v-for="(group, groupIndex) in analysisData" :key="`group-${groupIndex}`" grid-list-lg="true" pa-0 class="hvh-analysis-type-selector">
      <h3 :class="['hvh-h4', groupIndex > 0 ? 'mt-5' : 'mt-2']">{{ group.groupName }}</h3>
      <v-layout row wrap mt-2 fill-height="true">
        <v-flex xs3 v-for="item in group.groupData" :key="`item-${item.id}`">
          <v-item :value="item">
            <v-card slot-scope="{ toggle }" @click="toggle" class="hvh-card hvh-card--rounded hvh-card--border pa-3" flat>
              <h4 class="hvh-h5 mb-2">{{ item.name }}</h4>
              <p>{{ item.description }}</p>
            </v-card>
          </v-item>
        </v-flex>
      </v-layout>
    </v-container>
  </v-item-group>
</template>

<script>
export default {
  props: ['item', 'analysisData'],
};
</script>

<style lang="scss">
.hvh-analysis-type-selector {
  .hvh-card {
    height: 100%;
  }

  .hvh-card--teal {
    .hvh-h5 {
      color: $color-white;
    }
  }
}
</style>
